<template>
  <div class="mvt-cardproperty-photo" @click.stop="onClick" :data-mls="property.formatMlsInfo || null" :data-alt="property.photoCount > 0 ? null : 'Photos coming soon'">
    <mvtMapStatic v-if="showStreetView && property.photoCount === 0" type="streetview" streetViewDefautType="satellite"
      :lat="property.geo.lat" :lng="property.geo.lng" :address="property.geo.formatAddress"
      :title="property.geo.formatAddress" :alt="property.geo.formatAddress" :width="staticMapData.width"
      :height="staticMapData.height" :cacheFirst="true" />
    <img
      :loading="isPreload ? 'eager' : 'lazy'"
      :fetchpriority="isPreload ? 'high' : 'auto'"
      decoding="async"
      :src="photoUrl"
      :alt="property.photoCount > 0 ? property.geo.formatAddress : 'Photos coming soon'"
      width="320"
      height="200"
    />
    <button class="btn-3d" type="button"
      v-if="glb.pageType === 'vmapsearch' && property.isActive && property.threeDTourLink" data-link-name="3D">
      <img loading="lazy" fetchpriority="auto" :src="glb.cdnUrl + 'vimages/home_animate.svg'" alt="3D Tour" />
    </button>
  </div>
</template>

<script src="./mvt-cardproperty-image.js"></script>
